import Toast from 'components/Toasts'
import React, { createContext, useMemo, useState } from 'react'

const initialShowToast = {
  message: '',
  error: false,
  duration: 0,
  onClose: () => {},
  severity: '',
}

export const toastContext = createContext({
  setToastOptions: (options = initialShowToast) => {},
})

const ToastContext = ({ children }) => {
  const [toastOptions, setToastOptions] = useState({})

  const handleClose = () => {
    toastOptions.onClose?.()
    setToastOptions((ps) => ({ ...ps, show: false }))
  }

  const contextValue = useMemo(() => {
    return {
      setToastOptions: (options) =>
        setToastOptions((ps) => ({ ...ps, ...options, show: true })),
    }
  }, [])
  return (
    <toastContext.Provider value={contextValue}>
      <Toast
        show={toastOptions.show}
        duration={toastOptions.duration}
        onClose={handleClose}
        message={toastOptions.message}
        error={toastOptions.error}
        severity={toastOptions.severity}
      />
      {children}
    </toastContext.Provider>
  )
}

export default ToastContext
